export enum ListMode {
  SingleSelect = "SingleSelect",
  MultiSelect = "MultiSelect",
  SingleContent = "SingleContent",
  RadioGroup = "RadioGroup",
}

export enum ListStyleType {
  None = "None",
  Circle = "Circle",
  Number = "Number",
  Icon = "Icon",
}

export enum ListItemSize {
  Standard = "Standard",
  Large = "Large",
}

export enum AdditionalTextState {
  None = "None",
  Success = "Success",
  Warning = "Warning",
  Error = "Error",
  Information = "Information",
}

export interface LetterPressedHandlerObj {
  getPressedKey: () => string,
  setPressedKey: (arg: string) => void,
  getPressedCount: () => number,
  setPressedCount: (arg: number) => void,
  getLastFoundPosition: () => number,
  setLastFoundPosition: (arg: number) => void,
}
